import React from "react";
import { Form, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { validatePassword } from "../utils/passwordValidator";

const PASSWORD_PLACEHOLDER =
  "Min 10 chars, 2 upper, 2 lower, 2 number, 2 symbol";

const PasswordHint = () => (
  <Tooltip title="At least 10 characters · 2 Uppercase · 2 Lowercase · 2 Number · 2 Special character">
    <InfoCircleOutlined style={{ color: "#888", marginLeft: 6 }} />
  </Tooltip>
);

const passwordValidator = (required) => (_, value) => {
  if (!value) {
    return required
      ? Promise.reject(new Error("Password is required"))
      : Promise.resolve();
  }
  const errors = validatePassword(value);
  return errors.length
    ? Promise.reject(new Error(errors.join(" · ")))
    : Promise.resolve();
};

export default function PasswordFields({ required = true }) {
  const passwordValue = Form.useWatch("password");
  const confirmPasswordValue = Form.useWatch("confirmPassword");

  const isPasswordValid =
    Boolean(passwordValue) && validatePassword(passwordValue).length === 0;
  const isConfirmPasswordValid =
    Boolean(confirmPasswordValue) &&
    isPasswordValid &&
    passwordValue === confirmPasswordValue;

  return (
    <>
      <Form.Item
        name="password"
        label={
          <span>
            Password <PasswordHint />
          </span>
        }
        validateStatus={isPasswordValid ? "success" : undefined}
        extra={
          isPasswordValid ? (
            <span style={{ color: "#52c41a" }}>Password format is valid</span>
          ) : null
        }
        rules={[{ validator: passwordValidator(required) }]}
        hasFeedback
      >
        <Input.Password
          placeholder={
            required ? PASSWORD_PLACEHOLDER : "Leave blank to keep current"
          }
        />
      </Form.Item>

      <Form.Item
        name="confirmPassword"
        label={required ? "Confirm Password" : "Confirm New Password"}
        dependencies={["password"]}
        validateStatus={isConfirmPasswordValid ? "success" : undefined}
        extra={
          isConfirmPasswordValid ? (
            <span style={{ color: "#52c41a" }}>Passwords match</span>
          ) : null
        }
        hasFeedback
        rules={[
          ...(required
            ? [{ required: true, message: "Please confirm your password" }]
            : []),
          ({ getFieldValue }) => ({
            validator(_, value) {
              const pwd = getFieldValue("password");
              if (!pwd && !value) return Promise.resolve();
              if (pwd === value) return Promise.resolve();
              return Promise.reject(new Error("Passwords do not match"));
            },
          }),
        ]}
      >
        <Input.Password placeholder="Confirm password" />
      </Form.Item>
    </>
  );
}
